module.exports = __webpack_public_path__ + "static/Ps-39c367cfeae9981e4dbc503828f98be4.png";